module.exports = __webpack_public_path__ + "static/media/icon-balcony.30bb7f6a.svg";